var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import axios from 'axios';

function getHost() {
  if (typeof global !== 'undefined' && global.paymentIQHost) return global.paymentIQHost;
  if (typeof window !== 'undefined' && window.paymentIQHost) return window.paymentIQHost;
  return 'https://test-api.paymentiq.io/paymentiq/api';
}

function NetworkException(data) {
  this.value = data;
  this.isNetworkException = true;
}

var isDefined = function isDefined(data) {
  return typeof data !== 'undefined';
};

var identity = function identity(data) {
  return data;
};

export var fetchJSON = function fetchJSON(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return axios(_extends({
    url: '' + getHost() + url
  }, options)).catch(function (error) {
    try {
      var errorJson = JSON.parse(error);
      throw new NetworkException(errorJson);
    } catch (err) {
      throw new NetworkException(error);
    }
  });
};

var isString = function isString(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'object' && value != null && !Array.isArray(value) && getTag(value) == '[object String]';
};

var isNumber = function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == '[object Number]';
};

var isRequired = function isRequired(value) {
  if (value == null || typeof value === 'undefined') return false;

  if (isString(value) && value.trim().length === 0) {
    return false;
  }

  return true;
};

var availableRules = {
  string: isString,
  number: isNumber,
  required: isRequired
};

var getErrorMessage = function getErrorMessage(method, name) {
  switch (method) {
    case 'string':
      return name + ' must be a string';
    case 'number':
      return name + ' must be a number';
    case 'required':
      return name + ' is required';
    default:
      return name + ' is invalid';
  }
};

var validate = function validate(rules, data) {
  var result = {
    isValid: true,
    errors: {}
  };

  Object.keys(rules).map(function (key) {
    var checkMethods = rules[key].split('|');

    checkMethods.forEach(function (method) {
      var checkMethod = availableRules[method];
      if (!checkMethod) {
        throw new Error('validation method ' + method + ' is not supported');
      }

      if (!checkMethod(data[key])) {
        result.isValid = false;
        result.errors[key] = getErrorMessage(method, key);
      }
    });
  });

  return result;
};

export var processPayment = function processPayment(url, rules) {
  var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  var customConditional = arguments[3];
  return function (requestData, user) {
    var result = validate(rules, requestData);
    var transformedData = transform(requestData, user);

    if (!result.isValid) {
      return Promise.reject(result);
    }

    if (customConditional) {
      try {
        customConditional(requestData);
      } catch (error) {
        return Promise.reject({
          isValid: false,
          errors: {
            message: error.message
          }
        });
      }
    }

    var selectedLocale = transformedData.locale || 'en_GB';

    return fetchJSON(url + '?locale=' + selectedLocale, {
      method: 'POST',
      data: transformedData
    });
  };
};

export var mobilePayParser = function mobilePayParser(phoneNumber) {
  return phoneNumber.replace(/^00(45|46|47|358)0/, function (f, m) {
    return '+' + m;
  }) // Use + not 00 and drop leading zero
  .replace(/^\+(45|46|47|358)0/, function (f, m) {
    return '+' + m;
  }) // Drop leading zero
  .replace(/^00/, '+');
};

export default {
  fetchJSON: fetchJSON,
  processPayment: processPayment,
  isRequired: isRequired,
  mobilePayParser: mobilePayParser
};